import ar from './ar.json';
import bg from './bg.json';
import bn from './bn.json';
import de from './de.json';
import el from './el.json';
import en from './en.json';
import es from './es.json';
import fa from './fa.json';
import fr from './fr.json';
import hi from './hi.json';
import it from './it.json';
import ja from './ja.json';
import kk from './kk.json';
import ko from './ko.json';
import ms from './ms.json';
import pl from './pl.json';
import pt from './pt.json';
import sw from './sw.json';
import ta from './ta.json';
import tr from './tr.json';
import ua from './ua.json';
import zn from './zn-cn.json';
import ru from './ru.json'

const locales = {
  ar,
  bg,
  bn,
  de,
  ru,
  el,
  en,
  es,
  fa,
  fr,
  hi,
  it,
  ja,
  kk,
  ko,
  ms,
  pl,
  pt,
  sw,
  ta,
  tr,
  ua,
  zn,
};

export default locales;
